<template>
  <div>
    <div class="wrapper">
      <nav-menu/>
      
      <div style="margin-top: 43px;">
        <header class="w3-container w3-center">
          <h5>
            <i class="fa fa-user-clock w3-text-theme"/>
            <span>Acessos do ADMWeb</span>
          </h5>
        </header>

        <exibir-processando v-if="processando"/>

        <div class="w3-container w3-padding-small">

          <div 
            id="lbinicio" 
            class="w3-left w3-col m4 s12 l3 w3-padding-small w3-block">
            
            <strong>Data inicial</strong>
            <input
              class="w3-input w3-border"
              type="date"
              maxlength="10"
              v-model="data_inicial"
              @keypress="validarData(data_inicial)"/>
          </div>

          <div 
            id="lbfinal"
            class="w3-left w3-col m4 s12 l3 w3-padding-small w3-block">
            
            <strong >Data final</strong>
            <input
              class="w3-input w3-border"
              type="date"
              maxlength="10"
              v-model="data_final"
              @keypress="validarData(data_final)"/>
          </div>

          <div id="lbvendedor" class="w3-left w3-col s12 l6 w3-padding-small w3-block">
            <frame-funcionario
              ref="frFuncionario"
              somenteLeitura="N"
              @confirmar="adicionarFuncionario"
              @limparDados="limparFuncionario"
            />
          </div>

          <div id="lbmotorista" class="w3-left w3-col s12 l6 w3-padding-small w3-block">
            <frame-motorista
              ref="frMotorista"
              somenteLeitura="N"
              @confirmar="adicionarMotorista"
              @limparDados="limparMotorista"
            />
          </div>

          <div id="lbfornecedor" class="w3-left w3-col s12 l6 w3-padding-small w3-block">
            <frame-fornecedor
              ref="frFornecedor"
              somenteLeitura="N"
              @confirmar="adicionarFornecedor"
              @limparDados="limparFornecedor"
            />
          </div>

          <div class="w3-left w3-col s12 l6 w3-padding-small w3-block">
            <strong>Modo lite</strong>
            <select class="w3-select w3-border" v-model="modo_lite">
              <option value="NF" default>Não filtrar</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>

          <div class="w3-left w3-col s6 l3 w3-padding-small w3-block">
            <strong class="w3-hide-small">Tipo de velocidade (Mb/s): </strong>
            <strong class="w3-hide-medium w3-hide-large">Tipo de veloc. (Mb/s): </strong>
            <select class="w3-select w3-border" v-model="tipo_filtro_velocidade">
              <option value=">" default>Deve ser maior que </option>
              <option value=">=" >Deve ser maior ou igual a </option>
              <option value="<">Deve ser menor que</option>
              <option value="<=">Deve ser menor ou igual a</option>
              <option value="=">Deve ser igual a</option>
            </select>
          </div>

          <div class="w3-left w3-col s6 l3 w3-padding-small w3-block">
            <div class="w3-col s1">
              <legenda>
                <div>Será considerado a velocidade (MB/s) somente se o valor informado for maior que 0.</div>
                <i slot="referencia" style="font-size: 15px; " class="fa fa-info-circle w3-text-blue"></i>
              </legenda>
            </div>

            <div class="w3-col s11">
              <strong class="w3-block">Velocidade (Mb/s)</strong>
            </div> 

            <input 
              type="number"
              maxlength="10" 
              v-model="velocidade"
              class="w3-input w3-border"
              placeholder="Digite a velocidade (Mb/s)"/>
          </div>

          <div class="w3-center w3-left w3-col s12 w3-padding-small w3-block">
            <button 
              class="w3-button w3-theme"
              style="font-size: 14px; margin-top: 5px;"
              v-on:click="buscarRelacaoAcessosADMWeb()">
              <i class="fas fa-search"></i>
              <span>Pesquisar</span>
            </button>
          </div>
        </div>
      
        <div
          :key="index"
          style="margin:5px; font-size: 14px;"
          class="card-item w3-border w3-container"
          v-for="(acesso, index) in acessos_admweb">
          
          <div class="w3-col w3-left" v-if="(acesso.nome_funcionario) && (acesso.tipo_autenticacao == 'UAD')">
            <label> Funcionário: </label>
            <strong class="w3-text-theme"> <i class="fa fa-user"/> {{ acesso.funcionario_id + ' - ' + acesso.nome_funcionario }}</strong>
          </div>

          <div class="w3-col w3-left" v-if="acesso.nome_motorista">
            <label>Motorista: </label>
            <strong class="w3-text-green"> <i class="fa fa-truck"/> {{ acesso.motorista_id + ' - ' + acesso.nome_motorista }}</strong>
          </div>

          <div class="w3-col w3-left" v-if="acesso.nome_fornecedor">
            <label>Fornecedor: </label>
            <strong class="w3-text-blue"> <i class="fa fa-cart-arrow-down"/> {{ acesso.fornecedor_id + ' - ' + acesso.nome_fornecedor }}</strong>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.autenticacao_id">
            <label>Autenticação: </label>
            <label>{{ acesso.autenticacao_id }}</label>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.data_hora_criacao_conexao">
            <label>Data/hora de criação acesso: </label>
            <label>{{ acesso.data_hora_criacao_conexao }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.nome_fantasia">
            <label>Empresa: </label>
            <label>{{ acesso.empresa_id + ' - ' + acesso.nome_fantasia }}</label>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.data_hora_ultimo_acesso">
            <label>Data/hora último acesso: </label>
            <label>{{ acesso.data_hora_ultimo_acesso }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.descricao_dispositivo">
            <label>Dispositivo: </label>
            <label>{{ acesso.descricao_dispositivo }}</label>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.modo_lite_ativo">
            <label>Modo lite ativo: </label>
            <strong :style="getStyleAzulVermelho(acesso.modo_lite_ativo, true)">{{ acesso.modo_lite_ativo }}</strong>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.ip">
            <label>IP: </label>
            <label>{{ acesso.ip }}</label>
          </div>
          
          <div class="w3-col w3-left" v-if="acesso.sistema_operacional">
            <label>Sistema operacional: </label>
            <label>{{ acesso.sistema_operacional }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.navegador">
            <label>Navegador: </label>
            <label>{{ acesso.navegador }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.velocidade_kb">
            <label>Velocidade: </label>
            <label>{{ acesso.velocidade_kb }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.nome_usuario_santri">
            <label>Nome usuário santri: </label>
            <label>{{ acesso.nome_usuario_santri }}</label>
          </div>

          <div class="w3-col w3-left" v-if="acesso.ultimo_orcamento_id">
            <label>Último pedido no ADMWeb: </label>
            <label>{{ acesso.ultimo_orcamento_id }}</label>
          </div>

          <div class="w3-center" style="margin-bottom: 5px; margin-top: 5px;" v-show="!acesso.mostrar_detalhes">
            <button 
              class="w3-button w3-theme"
              style="margin-top: 5px;"
              v-on:click="buscarAutenticacoesRequisicoes(index)">
              {{ '+ Ver autenticações requisições' }}
            </button>
          </div>

          <div class="w3-center" style="margin-bottom: 5px; margin-top: 5px;" v-show="acesso.mostrar_detalhes">
            <button 
              class="w3-button w3-theme"
              style="margin-top: 5px;"
              v-on:click="buscarAutenticacoesRequisicoes(index)">
              {{ '- Ocultar autenticações requisições' }}
            </button>
          </div>

          <div style="padding:0px;" v-show="(acesso.mostrar_detalhes) && (Object.keys(acesso.autenticacoes_requisicoes).length > 0)">
            
            <div style="font-size: 10px;!important;" class="w3-container w3-hide-small w3-hide-medium w3-responsive w3-margin-top" v-cloak>
              <table class="w3-table-all" style="font-size: 16px;">
                <thead>
                  <tr>
                    <th>Classe rest</th>
                    <th>Operação</th>
                    <th>Data/hora</th>
                    <th>Velocidade</th> 
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    :key="index_requisicoes"
                    style="cursor: pointer;"
                    v-for="(requisicao, index_requisicoes) in acesso.autenticacoes_requisicoes">
                    <td>{{requisicao.classe_rest}}</td>
                    <td>{{requisicao.operacao}}</td>
                    <td>{{requisicao.data_hora}}</td>
                    <td>{{requisicao.velocidade_kb}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="w3-container w3-hide-large" style="padding:0px 0px 0px 0px">
              <div 
                :key="index_requisicoes"
                style="font-size: 14px;"
                class="w3-container card-item w3-border w3-white margin-top"
                v-for="(requisicao, index_requisicoes) in acesso.autenticacoes_requisicoes">

                <div class="w3-col w3-left" v-if="requisicao.classe_rest">
                  <label>Classe rest: </label>
                  <label style="color: #8a4343;">{{ requisicao.classe_rest }}</label>
                </div>

                <div class="w3-col w3-left" v-if="requisicao.operacao">
                  <label>Operação: </label>
                  <label style="color: #436c8a;">{{ requisicao.operacao }}</label>
                </div>

                <div class="w3-col w3-left" v-if="requisicao.data_hora">
                  <label>Data/hora: </label>
                  <label>{{ requisicao.data_hora }}</label>
                </div>

                <div class="w3-col w3-left" v-if="requisicao.velocidade_kb">
                  <label>Velocidade: </label>
                  <label>{{ requisicao.velocidade_kb }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>   
    </div>  
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu';
  import Legenda from '@/components/Legendas'
  import RSessao from '@/components/Rest/RSessao.js'
  import FrameMotorista from './Frames/FrameMotorista.vue';
  import FrameFornecedor from './Frames/FrameFornecedor.vue';
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import FrameFuncionario from '@/components/Frames/FrameFuncionario'

  export default {
    name: 'AcessosADMWeb',
    
    components: {
      NavMenu,
      Legenda,
      FrameMotorista,
      FrameFornecedor,
      FrameFuncionario,
      ExibirProcessando,
    },

    data () {
      return {
        data_inicial: '',
        data_final: '',
        velocidade: '',
        modo_lite: 'NF',
        tipo_filtro_velocidade: '>',
        
        acessos_admweb: [],
        processando: false,
        
        motorista_selecionado: {},
        fornecedor_selecionado: {},
        funcionario_selecionado: {},
      }
    },

    methods: {
      async buscarRelacaoAcessosADMWeb(){
        try {
          this.processando = true;
          this.acessos_admweb = [];

          let parametros = {
            data_inicial: Biblioteca.fData(this.data_inicial),
            data_final: Biblioteca.fData(this.data_final),
            funcionario_id: this.funcionario_selecionado.funcionario_id,
            motorista_id: this.motorista_selecionado.motorista_id,
            fornecedor_id: this.fornecedor_selecionado.fornecedor_id,
            modo_lite: this.modo_lite,
            velocidade: this.velocidade,
            tipo_filtro_velocidade: this.tipo_filtro_velocidade
          };

          let retorno = await RSessao.buscarRelacaoAcessosADMWeb(this.axios, parametros);
          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }
          
          this.acessos_admweb = JSON.parse(JSON.stringify(retorno.dados));
          this.processando = false;
        }
        catch (e) {
          this.processando = false;
          swal(e.message);
        }
      },

      async buscarAutenticacoesRequisicoes(index){
        try {
          this.acessos_admweb[index].mostrar_detalhes = this.acessos_admweb[index].mostrar_detalhes ? false : true;

          if (!this.acessos_admweb[index].mostrar_detalhes){
            this.$forceUpdate();
            return;
          }

          let parametros = {
            autenticacao_id: this.acessos_admweb[index].autenticacao_id
          };

          this.acessos_admweb[index].autenticacoes_requisicoes = [];
          let retorno = await RSessao.buscarAutenticacoesRequisicoes(this.axios, parametros);
          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }
          
          this.acessos_admweb[index].autenticacoes_requisicoes = JSON.parse(JSON.stringify(retorno.dados));
          this.$forceUpdate();
        }
        catch (e) {
          swal(e.message);
          this.acessos_admweb[index].mostrar_detalhes = false;
          this.$forceUpdate();
        }
      },

      adicionarFuncionario(funcionario) {
        this.funcionario_selecionado = JSON.parse(JSON.stringify(funcionario));
      },

      limparFuncionario() {
        this.funcionario_selecionado = {};
      },

      adicionarMotorista(motorista) {
        this.motorista_selecionado = JSON.parse(JSON.stringify(motorista));
      },

      limparMotorista() {
        this.motorista_selecionado = {};
      },

      adicionarFornecedor(fornecedor) {
        this.fornecedor_selecionado = JSON.parse(JSON.stringify(fornecedor));
      },

      limparFornecedor() {
        this.fornecedor_selecionado = {};
      },

      validarData(data) {
        let data_entrada = new Date(Date.parse(data)).toLocaleDateString();
        return data_entrada;
      },

      getStyleAzulVermelho(valor, inverter_cor) {
        return Biblioteca.corAzulVermelho(valor, inverter_cor);
      },

      dateToString(dia, mes, ano) {
        return ano + "-" + mes.padStart(2, "0") + "-" + dia.padStart(2, "0");
      },

      async aplicarfiltroMesAtual(){
        this.data_inicial = await this.dateToString(
          '1',
          (new Date().getMonth() + 1).toString(),
          new Date().getFullYear().toString()
        );

        this.data_final = await this.dateToString(
          new Date().getDate().toString(),
          (new Date().getMonth() + 1).toString(),
          new Date().getFullYear().toString()
        );
      }
    },

    async created() {
      await this.aplicarfiltroMesAtual();
      await this.buscarRelacaoAcessosADMWeb();
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }
</style>


// WEBPACK FOOTER //
// src/components/AcessosADMWeb.vue